export class ResponseBody{
    function: string 
    result:string
    resultmessage:string
    payload:any
    token:string
}